import React from 'react';

import {Link as RouterLink} from 'react-router-dom';

import classNames from 'classnames';

import './styles.css';

const Link = ({
  children,
  to,
  className,
  primary,
  blue,
  white,
  current
}: any) => (
  <RouterLink
    to={to}
    className={classNames(className, 'Link colab-bold', {
      primary,
      blue,
      white,
      current
    })}>
    {children}
  </RouterLink>
);

export default Link;
